import React from 'react';
import clsx from 'clsx';

const SRC_MAP = {
  horizontal: {
    light: '/brand/linirio-horizontal-color-light-removebg-preview.png',
    dark: '/brand/linirio-horizontal-color-dark.svg',
    'mono-light': '/brand/linirio-horizontal-mono-black-light.svg',
    'mono-dark': '/brand/linirio-horizontal-mono-white-dark.svg',
    'muted-light': '/brand/linirio-horizontal-mono-gray-light.svg',
    'muted-dark': '/brand/linirio-horizontal-mono-gray-dark.svg',
  },
  icon: {
    light: '/brand/linirio-icon-color-light.svg',
    dark: '/brand/linirio-icon-color-dark.svg',
    'mono-light': '/brand/linirio-icon-mono-black-light.svg',
    'mono-dark': '/brand/linirio-icon-mono-white-dark.svg',
    'muted-light': '/brand/linirio-icon-mono-gray-light.svg',
    'muted-dark': '/brand/linirio-icon-mono-gray-dark.svg',
  },
};

const SIZE_MAP = {
  horizontal: {
    sm: 'h-[28px]',
    md: 'h-[36px]',
    lg: 'h-[48px]',
    xl: 'h-[64px]',
  },
  icon: {
    sm: 'h-[28px] w-[28px]',
    md: 'h-[40px] w-[40px]',
    lg: 'h-[56px] w-[56px]',
    xl: 'h-[80px] w-[80px]',
  },
};

export default function BrandLogo({
  variant = 'horizontal',
  tone = 'light',
  size = 'md',
  className,
  alt = 'Linirio',
  loading = 'lazy',
}) {
  const src = SRC_MAP[variant]?.[tone] || SRC_MAP.horizontal.light;
  const sizeClass = SIZE_MAP[variant]?.[size] || SIZE_MAP.horizontal.md;

  return (
    <img
      src={src}
      alt={alt}
      loading={loading}
      decoding="async"
      draggable="false"
      className={clsx(
        'block max-w-full select-none object-contain shrink-0',
        sizeClass,
        className,
      )}
    />
  );
}
